export enum SummaryType {
    SUM = 'sum',
    AVG = 'avg',
    MIN = 'min',
    MAX = 'max'
}
